import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
    card: {
        margin: '0px !important',
        padding: theme.spacing(2),
        boxShadow: "0 6px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: theme.spacing(2),
        height: '100% !important',
        overflow: 'auto !important',
        [theme?.breakpoints?.down('sm')]: {
            margin: '0px !important',
        },
        [theme?.breakpoints?.down('xs')]: {
            margin: '0px !important',
        },
    },
    contactWrapper: {
        width: '100%',
        padding: 10,
    },
    imgContainer: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 15,
        borderBottom: '2px solid #005eb2',
        paddingBottom: 8,
    },
    brandImg:{
        width: 270,
    },
    hedaing: {
        fontSize: 14,
    },
    valueTxt: {
        fontSize: 13,
    },
    contactsBox: {
        display: 'flex',
        alignItems: 'center',
        gap: '1.5rem',
    },
    contactsBoxAvatar: {
        display: 'flex',
        alignItems: 'center',
        gap: '1.5rem',
        [theme?.breakpoints?.down('xs')]: {
            flexDirection: 'column',
        },
    },
    aagentAvatar: {
        width: 90,
        height: 90,
    },
    contactDetailEmpty: {
        display: 'flex',
        alignItems: 'center',
        gap: 3,
        height: 22,
    },
    mapDiv: {
        width: '100%',
        height: 300,
        [theme.breakpoints.down('xs')]: {
            height: 300,
        }
    },
    descriptionText: {
        fontSize: 14,
        fontWeight: 500,
    },
    customeGallery: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    contactDetail: {
        display: 'flex',
        alignItems: 'center',
        gap: 3
    },
    fullWidth: {
        width: '100%',
    },
    mapGrid: {
        width: '100%',
        justifyContent: 'space-between',
        height: 300,
        marginTop: 10,
        paddingLeft: 10,
        [theme.breakpoints.down('xs')]: {
            height: '100%',
        }
    },
    grid2: {
        paddingRight: 0,
    },
    floorImg: {
        width: '100%',
        height: 250,
        objectFit: 'cover',
        [theme.breakpoints.down('xs')]: {
            height: '100%',
        }
    },
    imageDialog: {
        zIndex: 10000000000,
    },
    skell1: {
        width: '100%',
        height: '300px',
        objectFit: 'cover',
        display: 'block',
        borderRadius: 5,
    },
    galleryItem: {
        position: 'relative',
        display: 'inline-block',
        margin: '10px',
        width: '100%',
    },
    galleryItem2: {
        position: 'relative',
        display: 'inline-block',
        width: '100%',
    },
    galleryImage: {
        width: '100%',
        height: '120px',
        objectFit: 'cover',
        display: 'block',
        borderRadius: 10,
    },
    sectionTitle: {
        fontSize: "1.5rem",
        fontWeight: "bold",
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(1),
    },
    keyDetails: {
        marginBottom: theme.spacing(4),
    },
    detailItem: {
        display: "flex",
        alignItems: "center",
        marginBottom: theme.spacing(1),
    },
    detailIcon: {
        marginRight: theme.spacing(1),
        color: theme.palette.primary.main,
    },
    contactButton: {
        marginTop: theme.spacing(4),
        fontWeight: "bold",
    },
    showMoreButton: {
        marginTop: theme.spacing(2),
        textAlign: "center",
    },
    gItem: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center', // Center image
        overflow: 'hidden',
    },
    gImg: {
        width: '100%',
        height: '120px',
        objectFit: 'cover',
        display: 'block',
    },
    gContainer: {
        display: 'flex',
        alignItems: 'center',
        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
        justifyContent: 'center',
        width: '100%',
        gap: 10,
        height: 350,
        [theme.breakpoints.down('md')]: {
            height: '100%',
        },
    },
    galleryImage1: {
        width: '100%',
        height: '345px',
        objectFit: 'cover',
        display: 'block',
        borderRadius: 5,
    },
    galleryImage2: {
        width: '100%',
        height: '168px',
        objectFit: 'cover',
        display: 'block',
        borderRadius: 5,
    },
    firstImageContainer: {
        width: "75%",
        [theme.breakpoints.down('md')]: {
            width: '65%',
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    secondImageContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        width: "20%",
        gap: 10,
        [theme.breakpoints.down('md')]: {
            width: '30%',
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    imgBtn: {
        fontWeight: 600,
    },
    skeletonStyle: {
        width: '100%',
        height: 350,
        [theme.breakpoints.down('md')]: {
            height: '100%',
        },
    },
    placeholderImage: {
        width: '100%',
        objectFit: "contain",
        height: 350,
        [theme.breakpoints.down('md')]: {
            height: '100%',
        },
    },
    cardWrapper: {
        padding: theme.spacing(2),
        borderRadius: 8,
        boxShadow: theme.shadows[3],
        backgroundColor: '#fafafa',
    },
    header: {
        marginBottom: theme.spacing(2),
    },
    headerTitle: {
        fontWeight: 'bold',
        fontSize: 18,
        color: '#333',
    },
    headerDivider: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        backgroundColor: '#ddd !important',
    },
    contactInfoWrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
    },
    iconStyle: {
        marginRight: theme.spacing(1.5),
        fontSize: 20,
    },
    textStyle: {
        fontSize: 16,
        color: '#555',
        fontWeight: '400',
        wordBreak: 'break-all',
    },
    flexImg: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
    },
    imgCls: {
        width: '50%',
        objectFit: 'cover',
        height: 350,
        [theme.breakpoints.down('md')]: {
            height: 200,
        },
    },
    fullImg: {
        width: '100%',
        objectFit: 'cover',
        height: 350,
        [theme.breakpoints.down('md')]: {
            height: 200,
        },
    },
}));
